// extracted by css-extract-rspack-plugin
export default {"cls1":"blurred_takeaways-cls1_p6T","cls2":"blurred_takeaways-cls2_LgQ blurred_takeaways-cls1_p6T"};